import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { State } from './store/main';
import { ResolveSession } from './store/auth/actions';
import {
  StorageServiceToken,
  IStorageService,
} from './services/storage/interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  public title = 't-portal';
  constructor(
    private router: Router,
    private store: Store<State>,
    @Inject(StorageServiceToken) private storageService: IStorageService,
  ) {}

  ngOnInit() {
    // scroll view back to top after every navigation change.
    this.router.events.pipe(untilDestroyed(this)).subscribe({
      next: (evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      },
    });

    // attempt to resolve previous session
    this.store
      .pipe(select('auth', 'isAuthenticated'))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (isAuthed) => {
          if (isAuthed) return;
          const accessToken = this.storageService.getItem('accessToken');
          const fullName = this.storageService.getItem('fullName');
          if (accessToken !== null) {
            this.store.dispatch(new ResolveSession({ accessToken, fullName }));
          }
        },
      });
  }
}
